import React from 'react';
import ReactDOM from 'react-dom';
import HelpComponent from './HelpComponent';

class SensorThingRenderChart extends React.Component{
    constructor(){
        super();
        this.state = {
            sensor : [],
            sensorInterval : ""
        }
        this.sensorOpen = this.sensorOpen.bind(this);
    }
    componentDidMount(){
        let sensor = [];
        const SensorList = this.props.SensorList;
        let sensorInterval = "";
        SensorList.map(
            (sensorResources) => {
                sensor.push({
                    Name : sensorResources.name,
                    Layername : sensorResources.layername,
                    Url : sensorResources.api,
                    IsOpen : true
                });
            }
        );
        this.sensorOpen(sensor);
        sensorInterval = setInterval(this.sensorOpen,300000,sensor);
        this.setState({sensor:sensor,sensorInterval:sensorInterval});
    }
    componentWillUnmount(){
        let sensorInterval = this.state.sensorInterval;
        window.main.OView.removeTerrainOverlay("SensorThingRenderChart");  
        clearInterval(sensorInterval);
    }
    sensorOpen(SensorList){
        let sensor = SensorList;
        let sensorLodingNum = 1;                   

        let canvas = document.createElement("canvas");
        canvas.width = 4096;
        canvas.height = 4096;
		let ctx = canvas.getContext('2d');
        ctx.globalCompositeOperation = "lighten";
        
        let doLoadIot = function(url){
            let xhr = new XMLHttpRequest();
            let color = {};
			xhr.overrideMimeType("application/json");
            xhr.open('GET', url, true);
            xhr.onload  = function() {
                var jsonResponse = JSON.parse(xhr.responseText);
                var iotValue = jsonResponse;
                for(var i = 0;i<iotValue.length;i++){
                    var iotEntity = iotValue[i];
                    var iotThingLocations = iotEntity["Thing"]["Locations"][0].location.coordinates;
                    if(iotEntity["Observations"][0]){
                        var iotObservationsResult = iotEntity["Observations"][0]["result"];

                        if(parseInt(iotObservationsResult)>70){
                            color.r = 206;
                            color.g = 48;
                            color.b = 255;
                        }else if(parseInt(iotObservationsResult)<=70&&parseInt(iotObservationsResult)>64){
                            color.r = 153;
                            color.g = 0;
                            color.b = 0;
                        }else if(parseInt(iotObservationsResult)<=64&&parseInt(iotObservationsResult)>58){
                            color.r = 255;
                            color.g = 0;
                            color.b = 0;
                        }else if(parseInt(iotObservationsResult)<=58&&parseInt(iotObservationsResult)>53){
                            color.r = 255;
                            color.g = 100;
                            color.b = 100;
                        }else if(parseInt(iotObservationsResult)<=53&&parseInt(iotObservationsResult)>47){
                            color.r = 237;
                            color.g = 125;
                            color.b = 49;
                        }else if(parseInt(iotObservationsResult)<=47&&parseInt(iotObservationsResult)>41){
                            color.r = 255;
                            color.g = 192;
                            color.b = 0;
                        }else if(parseInt(iotObservationsResult)<=41&&parseInt(iotObservationsResult)>35){
                            color.r = 255;
                            color.g = 255;
                            color.b = 0;
                        }else if(parseInt(iotObservationsResult)<=35&&parseInt(iotObservationsResult)>25){
                            color.r = 112;
                            color.g = 173;
                            color.b = 71;
                        }else if(parseInt(iotObservationsResult)<=25&&parseInt(iotObservationsResult)>10){
                            color.r = 49;
                            color.g = 255;
                            color.b = 0;
                        }else if(parseInt(iotObservationsResult)<11){
                            color.r = 156;
                            color.g = 255;
                            color.b = 156;
                        }

                        draw(iotThingLocations[0],iotThingLocations[1],color);
                    }
                }
                const CANVAS_WIDTH = 4096;
                const CANVAS_HEIGHT = 4096;
                if(sensorLodingNum === (sensor.length)){
                    let canvasBuffer = ctx.getImageData(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT).data;
                    let visualizedDataGridBuffer = new Float32Array(CANVAS_WIDTH * CANVAS_HEIGHT);
                    for (let i = 0; i < CANVAS_WIDTH * CANVAS_HEIGHT; i++) {
                        visualizedDataGridBuffer[i] = (canvasBuffer[i * 4 + 2] / 255) * (canvasBuffer[i * 4 + 3] / 255);
                    }
                    var SensorThingRenderChartLayer =
                    {
                        layername: "SensorThingRenderChart",
                        source: [visualizedDataGridBuffer],
                        boundary: new window.GeoBoundary(118.0, 21.0, 123.0, 26.0),
                        width: CANVAS_WIDTH,
                        height: CANVAS_HEIGHT,
                        date: [new Date()],
                        useStepLayeredColorMap: false,

                    }                        
                    if(window.main.OView.getTerrainOverlay("SensorThingRenderChart") !== null){
                        window.main.OView.removeTerrainOverlay("SensorThingRenderChart");         
                    }
                    window.main.OView.addTerrainVisualizedDataGridOverlay(SensorThingRenderChartLayer, console.log); 
                }
                else if(sensorLodingNum < sensor.length){
                    sensorLodingNum++;
                }
            };
            xhr.send(null);
        };

        let BOUND_X_MIN = 118.0;
		let BOUND_X_MAX = 123.0;

		let BOUND_Y_MIN = 21.0;
		let BOUND_Y_MAX = 26.0;

		function draw(x,y,color) {
			let size = 40;
			let mx = (x - BOUND_X_MIN) / (BOUND_X_MAX - BOUND_X_MIN) * 4096;
			let my = 4096 - (y - BOUND_Y_MIN) / (BOUND_Y_MAX - BOUND_Y_MIN) * 4096;

			var radgrad = ctx.createRadialGradient(mx, my, 0, mx, my, size);
			radgrad.addColorStop(0, "rgba("+color.r+ "," + color.g + "," + color.b +",1.0)");
			radgrad.addColorStop(1.0, "rgba("+color.r+ "," + color.g + "," + color.b +",0.0)");
			ctx.fillStyle = radgrad;

			ctx.beginPath();
			ctx.arc(mx, my, size, .0, Math.PI * 2);
			ctx.fill();
		}

        sensor.map(
            (Sensor) => {
                doLoadIot(Sensor.Url);  
            }
        );
               
    }

    render(){
        return(
            <div>                
            </div>
        )
    }
}

class SensorThingBarChart extends React.Component{
    constructor(){
        super();
        this.state = {
            sensor : [],
            sensorHandle : [],
            sensorInterval : []
        }
        this.sensorOnClick = this.sensorOnClick.bind(this);
        this.sensorOpen = this.sensorOpen.bind(this);
        this.sensorClose = this.sensorClose.bind(this);
    }
    componentDidMount(){
        let sensor = [];
        const SensorList = this.props.SensorList;
        let sensorInterval = this.state.sensorInterval;
        SensorList.map(
            (sensorResources) => {
                sensor.push({
                    Name : sensorResources.name,
                    Layername : sensorResources.layername,
                    Url : sensorResources.api,
                    IsOpen : true
                });
            }
        );
        sensor.map(
            (sensorResources) => {
                this.sensorOpen(sensorResources);
                let IntervalID = setInterval(this.sensorOpen, 300000,sensorResources);
                sensorInterval.push({
                    Name : sensorResources.Name,
                    ID : IntervalID
                });
            }
        );
        this.setState({sensor:sensor,sensorInterval:sensorInterval});
    }
    componentWillUnmount(){
        let sensor = this.state.sensor;
        let sensorInterval = this.state.sensorInterval;
        sensor.map(
            (sensorResources) => {
                this.sensorClose(sensorResources);
            }
        ); 
        sensorInterval.map(
            (Interval) => {
                clearInterval(Interval.ID);
            }
        )
    }
    sensorOpen(sensor){
        let sensorHandle = this.state.sensorHandle;
        let customLayer = window.main.OView.findLayer(sensor.Name);
        if(customLayer === null){
            customLayer = window.main.OView.addCustomLayer({
                layername : sensor.Layername
            });
            sensorHandle.push({
                Name:sensor.Name,
                Handle:customLayer
            });
        }
        else{
            customLayer.removeAllEntity(); 
        }            
        let iotCustomEntity = [];
        let iotMap = new Map();
        let easeInOutQuad = function(t){
            return t<.5 ? 2*t*t : -1+(4-2*t)*t
        };
        let anime = function(){
			for(var i = 0;i<iotCustomEntity.length;i++){
				if(iotCustomEntity[i].nowLife<1.0){
					iotCustomEntity[i].nowLife+=0.05;
					if(iotCustomEntity[i].nowLife>1.0)
						iotCustomEntity[i].nowLife = 1.0;
					var updateHeight = easeInOutQuad(iotCustomEntity[i].nowLife) * iotCustomEntity[i].height;
					iotCustomEntity[i].hand.update({height:updateHeight});
				}
			}
			requestAnimationFrame(anime);
        }        
        requestAnimationFrame(anime);
        let doLoadIot = function(url){
            let xhr = new XMLHttpRequest();
            let color = "";
			xhr.overrideMimeType("application/json");
            xhr.open('GET', url, true);
            xhr.onload  = function() {
                var jsonResponse = JSON.parse(xhr.responseText);
                var iotValue = jsonResponse;
                for(var i = 0;i<iotValue.length;i++){
                    var iotEntity = iotValue[i];
                    var iotThingLocations = iotEntity["Thing"]["Locations"][0].location.coordinates;
                    var iotAreaDescription = iotEntity["Thing"]["properties"]["areaDescription"];
                    if(iotEntity["Observations"][0]){
                        var iotObservationsResult = iotEntity["Observations"][0]["result"];
                        iotMap.set(iotValue[i]["@iot.id"], iotValue[i]);

                        if(parseInt(iotObservationsResult)>70){
                            color = "#CE30FF";
                        }else if(parseInt(iotObservationsResult)<=70&&parseInt(iotObservationsResult)>64){
                            color = "#990000";
                        }else if(parseInt(iotObservationsResult)<=64&&parseInt(iotObservationsResult)>58){
                            color = "#ff0000";
                        }else if(parseInt(iotObservationsResult)<=58&&parseInt(iotObservationsResult)>53){
                            color = "#FF6464";
                        }else if(parseInt(iotObservationsResult)<=53&&parseInt(iotObservationsResult)>47){
                            color = "#ED7D31";
                        }else if(parseInt(iotObservationsResult)<=47&&parseInt(iotObservationsResult)>41){
                            color = "#FFC000";
                        }else if(parseInt(iotObservationsResult)<=41&&parseInt(iotObservationsResult)>35){
                            color = "#FFFF00";
                        }else if(parseInt(iotObservationsResult)<=35&&parseInt(iotObservationsResult)>25){
                            color = "#70AD47";
                        }else if(parseInt(iotObservationsResult)<=25&&parseInt(iotObservationsResult)>10){
                            color = "#31FF00";
                        }else if(parseInt(iotObservationsResult)<11){
                            color = "#9CFF9C";
                        }

                        var hand = customLayer.addBarEntity({
                            geo:new window.Geo3DPoint(iotThingLocations[0],iotThingLocations[1],0),
                            size: 150,
                            height: 0,
                            tooltip: iotAreaDescription,
                            color: color,
                            side:6
                        })
                        iotCustomEntity.push({
                            hand : hand,
                            nowLife : 0.0,
                            height : 100 * iotObservationsResult
                        });
                    }
                }
            };
            xhr.send(null);
        };
        doLoadIot(sensor.Url);        
        this.setState({sensorHandle:sensorHandle});
    }

    sensorClose(sensor){
        let layerHandle = this.state.sensorHandle;
        for(let i=0; i<layerHandle.length; i++){
            if(layerHandle[i].Name === sensor.Name){
                (layerHandle[i].Handle).removeAllEntity();
                window.main.OView.removeLayer(layerHandle[i].Handle);
                layerHandle.splice(i, 1);
            }
        };
        this.setState({sensorHandle:layerHandle});
    }

    sensorOnClick(sensorResources){
        let sensor = this.state.sensor;
        let sensorInterval = this.state.sensorInterval;
        sensor.map(
            (event) => {
                if(event === sensorResources){
                    event.IsOpen = !event.IsOpen;
                }                
            }
        );
        if(sensorResources.IsOpen){            
            this.sensorOpen(sensorResources);
            let IntervalID = setInterval(this.sensorOpen, 300000,sensorResources);
            sensorInterval.push({
                Name : sensorResources.Name,
                ID : IntervalID
            });
        }
        else{
            this.sensorClose(sensorResources);
            for(let i=0; i<sensorInterval.length; i++){
                if(sensorInterval[i].Name === sensorResources.Name){
                    clearInterval(sensorInterval[i].ID);
                    sensorInterval.splice(i, 1);
                }
            }
        }
        this.setState({sensor:sensor, sensorInterval:sensorInterval});
    }

    render(){
        const sensor = this.state.sensor;
        return(
            <div className="ts checkboxes" style={{padding : "5px 15px"}}>
                {
                    sensor.map(
                        (sensorResources) => 
                        <div className="ts checkbox">
                            <input type="checkbox" name="sensor" id={sensorResources.Name} checked={sensorResources.IsOpen} onClick={(e)=>this.sensorOnClick(sensorResources)}></input>
                            <label htmlFor={sensorResources.Name}>{sensorResources.Name}</label>
                        </div>
                    )
                }
            </div>
        )
    }
}

class SensorList extends React.Component{
    constructor(){
        super();
        this.state = {
            sensorList : [],
            isBarChart : true
        };
        this.sensorListClick = this.sensorListClick.bind(this);
    }
    componentDidMount(){
        let sensorList = [];
        (window.SENSORDATA).map(
            (List) => {
                sensorList.push({
                    name : List.name,
                    id : List.id,
                    img : List.img,
                    resources : List.resources,
                    IsOpen : false
                });
            }
        );
        this.setState({sensorList:sensorList});
    }
    sensorListClick(sensor){
        let sensorList = this.state.sensorList;
        sensorList.map(
            (List) => {
                if(List === sensor){
                    List.IsOpen = !List.IsOpen;
                }
                else{                    
                    List.IsOpen = false;
                }
            }
        );
        this.setState({sensorList:sensorList});
    }
    chartTypeChange(){
        this.setState({isBarChart:!this.state.isBarChart});
    }
    render(){
        const sensorList = this.state.sensorList;
        let barChart;
        let renderChart;
        if(this.state.isBarChart){
            barChart = "active disabled item";
            renderChart = "item";
        }
        else{
            barChart = "item";
            renderChart = "active disabled item";
        }
        return(
            <div>
                <div className="ts flatted evenly divided menu">
                    <a className={barChart} onClick={(e)=>this.chartTypeChange()}>
                        柱狀圖
                    </a>
                    <a className={renderChart} onClick={(e)=>this.chartTypeChange()}>
                        渲染圖
                    </a>
                </div> 
                <div className="ts checkboxes">
                    {
                        sensorList.map(
                            (List) => 
                            <div className="ts accordion item">
                                <div className="ts checkbox" key={List.name}>
                                    <input type="checkbox" name="sensorList" id={List.name} onClick={(e)=>this.sensorListClick(List)} defaultChecked={List.IsOpen}></input>
                                    <label htmlFor={List.name}>{List.name}</label>
                                </div>
                                {
                                    List.IsOpen?
                                    <div>
                                        {
                                            this.state.isBarChart?
                                            <SensorThingBarChart SensorList={List.resources} key={List.id}/> :
                                            <SensorThingRenderChart SensorList={List.resources} key={List.id}/>
                                        }                                        
                                        <img src={List.img} style={{
                                            display: "inline-block",
                                            position: "fixed",
                                            width: "45px",
                                            bottom: "0px",
                                            left: "480px"
                                        }}></img>
                                    </div>                                
                                    : null
                                }
                            </div>
                        )
                    }
                </div>
            </div>
            
        );        
    }
}

class IoTSensorThings extends React.Component{
    constructor(){
        super();
        this.sidebarSwitch = this.sidebarSwitch.bind(this);
        this.state = {
            helpMode : "None"
        };
    }    
    sidebarSwitch(){
        this.props.setIoTSensorThingsOpen();
    }    
    onHelpClick(mode){
        this.setState({helpMode : mode});
    }
    render(){   
        const isIoTSensorThingsOpen = this.props.isIoTSensorThingsOpen;
        const sideMenuCSS ={
            overflow : 'inherit',
            transform : isIoTSensorThingsOpen?'translate3d(0, 0, 0)':'translate3d(-120%, 0, 0)',
            width : '480px'
        };
        const titleCSS = {
            margin: '10px 10px 10px 10px'
        };
        if(this.state.helpMode === "IoTHelp"){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/XGyQNF7Ejho" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'))
        }
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));
        }
        return(
            <div>
                <div className="ts left vertical sidebar visible menu" id="sideMenu" style={sideMenuCSS}>
                    <div className="ts grid">
                        <div className="row" id="sideMenuTitle">
                            <div className="twelve wide column">
                                <h4 className="ts header" style={titleCSS}>
                                    <i className="wifi icon"></i>
                                    <div className="content">
                                        民生公共物聯網
                                    </div>
                                </h4>                  
                            </div>
                            <div className="two wide column" id="closeIconColumn" style={{alignSelf:"center",textAlign:"right"}}>
                                <button className="ts circular pulsing  icon button" style={{fontSize:"12px",background:"#ccc"}} onClick={(e)=>this.onHelpClick("IoTHelp")}>
                                    <i className="help small icon" ></i>
                                </button>                    
                            </div>
                            <div className="two wide column" id="closeIconColumn">
                                <i className="remove icon" id="closeIcon" onClick={(e)=>this.sidebarSwitch(e)}></i>                        
                            </div>
                        </div>
                    </div>                       
                    <SensorList />
                </div>
            </div>            
        );
    }
}

export default IoTSensorThings;